// extracted by mini-css-extract-plugin
export default {"close":"snackbar__close___ze_lu","warning":"snackbar__warning___PgADK","error":"snackbar__error___Sl9ZC","root":"snackbar__root___mDJBq"};